import PropTypes from 'prop-types';

const propType = {
  productType: PropTypes.string,
  price: PropTypes.number,
  product: PropTypes.string,
  userCurrency: PropTypes.shape({
    price: PropTypes.number,
    tax: PropTypes.number,
    total: PropTypes.number,
    symbol: PropTypes.string,
    code: PropTypes.string,
  }),
};

export default { propType };
